import { render, staticRenderFns } from "./ScreenTitle.vue?vue&type=template&id=0064a809"
import script from "./ScreenTitle.vue?vue&type=script&lang=js"
export * from "./ScreenTitle.vue?vue&type=script&lang=js"
import style0 from "./ScreenTitle.vue?vue&type=style&index=0&id=0064a809&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports